import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBooking = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_321_793)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2.34375 13.5312H12.6562M14.5 9.27242V10.5C14.5 11.0523 14.0523 11.5 13.5 11.5H1.5C0.947715 11.5 0.5 11.0523 0.5 10.5V9.27355C0.5 8.82201 0.802596 8.42649 1.23841 8.30837L5.28052 7.21287C5.71633 7.09476 6.01893 6.69923 6.01893 6.24769V4.19985C6.01893 3.79087 5.76989 3.42311 5.39013 3.27129L4.1533 2.77686C3.77354 2.62505 3.5245 2.25729 3.5245 1.84831V1.5C3.5245 0.947715 3.97221 0.5 4.5245 0.5H10.5067C11.059 0.5 11.5067 0.947715 11.5067 1.5V1.84831C11.5067 2.25729 11.2576 2.62505 10.8779 2.77686L9.64105 3.27129C9.26129 3.42311 9.01225 3.79087 9.01225 4.19985V6.24883C9.01225 6.69984 9.31415 7.09503 9.74928 7.21363L13.763 8.30761C14.1981 8.42621 14.5 8.82141 14.5 9.27242Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_321_793",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "currentColor"
		})
	}) })]
});
export default SvgIconBooking;
